/*
* vuex 的核心管理对象 store 对象模块
* */

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state:{
    userInfo:{},
    wxUserInfo:{},
    orderInfo:{},
    companyId:'',
    mpappid:{},
    service_id:'',
    Authorization:''
  },
  mutations:{
    setUserInfo(state,payload){
      state.userInfo=payload
    },
    setWxUserInfo(state,payload){
      state.wxUserInfo=payload
    },
    setOrderInfo(state,payload){
      state.orderInfo=payload
    },
    setCompanyId(state,payload){
      state.companyId=payload
    },
    setMpappid(state,payload){
      state.mpappid=payload
    },
    setService_id(state,payload){
      state.service_id=payload
    },
    setAuthorization(state,payload){
      state.Authorization=payload
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js